import { render, staticRenderFns } from "./customerSvg.vue?vue&type=template&id=1e5f9d48&"
import script from "./customerSvg.vue?vue&type=script&lang=js&"
export * from "./customerSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports